export default [
  {
    path: "/pdf/rxdetails/businesses/:businessId/users/:userId/prescriptions/:businessPrescriptionId/generatedby/:generatedByUserId",
    name: "pdf-rxdetails",
    props: true,
    component: () => import("@/views/pdf/RxDetails.vue"),
    meta: {
      hideNav: true,
    },
  },
  {
    path:
      "/pdf/lifefileorder/businesses/:businessId/users/:userId/prescriptions/:businessPrescriptionId/generatedby/:generatedByUserId/prescriber/:prescriberId/name/:prescriberName",
    name: "pdf-lifefileorder",
    props: true,
    component: () => import("@/views/pdf/LifefileOrderRxDetails.vue"),
    meta: {
      hideNav: true,
    },
  },
  {
    path: "/pdf/invoice/businesses/:businessId/users/:userId/charge/:chargeId",
    props: true,
    component: () => import("@/views/pdf/Invoice.vue"),
    meta: {
      hideNav: true,
    },
  },
];
